export const capitalizeFirstLetter = (s) => {
    if (!s || s.length < 1) {
        return s;
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
};
export default capitalizeFirstLetter;
